import { getProductPrice } from '@/pages/sale/utils';
import orderBy from 'lodash/orderBy';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      basket: [],

      basketLoading: false,
    };
  },
  computed: {
    ...mapGetters('sale', ['twoForOne', 'twoForOneWithoutProfessions']),
    basketComputed() {
      const basket = this.basket;
      let basketComputed = [];

      if (this.twoForOneWithoutProfessions) {
        let accumulatorOfBonusCourses = 0;

        basketComputed = orderBy(
          basket,
          ['price.price', 'type', 'shortName'],
          ['desc', 'desc', 'asc'],
        ).map((item) => {
          const _item = { ...item };

          if (item.type === 1) {
            accumulatorOfBonusCourses++;
          } else {
            if (accumulatorOfBonusCourses > 0) {
              accumulatorOfBonusCourses--;
              _item.free = true;
              _item.freeTwoForOne = true;
            } else {
              accumulatorOfBonusCourses++;
            }
          }

          return _item;
        });

        return basketComputed;
      } else if (this.twoForOne) {
        basketComputed = orderBy(
          basket,
          ['price.price', 'shortName'],
          ['desc', 'asc'],
        ).map((item, index) => {
          const _item = { ...item };
          if ((index + 1) % 2 === 0) {
            _item.free = true;
            _item.freeTwoForOne = true;
          }

          return _item;
        });

        return basketComputed;
      } else {
        return basket;
      }
    },
  },
  async created() {
    if (process.client) {
      await this.setBasket();
    }
  },
  methods: {
    async setBasket() {
      const vue = this;
      const basketFromLocalStorage = this.getBasketFromLocalStorage();

      // Если тип корзины 3, то данные, которые ранее были добавлены в LS не должны учитываться
      // Это будет актуально в том случае, если корзина на этой же распродаже раньше была другого типа
      if (vue.basketType === 3) return;
      if (!basketFromLocalStorage.length) return;

      this.basketLoading = true;
      const nomenclatures = await this.getAllNomenclatures();

      this.basket = basketFromLocalStorage.reduce(
        (acc, productFromLocalStorage) => {
          const nomenclature = nomenclatures.find(
            (nomenclature) => nomenclature.id === productFromLocalStorage,
          );

          if (nomenclature) {
            nomenclature.price = getProductPrice(nomenclature, vue);
            acc.push(nomenclature);
          }

          return acc;
        },
        [],
      );

      this.basketLoading = false;
    },
    async getAllNomenclatures() {
      let response;
      let idsFromLocalStorage = localStorage.getItem(
        `sale-${this.$store.state.sale.sale.id}`,
      );
      try {
        const latam = ['pe', 'co', 'ar', 'cl'].includes(
          this.$app?.config?.common?.currentCountry,
        );
        response = await this.$axios({
          method: 'GET',
          // TODO: поменять на V2
          url: `${this.$app.config.current.CMS_REST_API}/public/v2/showcase/`,
          params: {
            saleId: this.$store.state.sale.sale.id,
            latam,
            country: this.$app?.config?.common?.currentCountry,
            ids: JSON.parse(idsFromLocalStorage),
          },
        });
      } catch (e) {
        console.error(e);
      }

      if (response?.data?.data?.data) {
        return response.data.data.data;
      } else {
        return [];
      }
    },
    setProductInLocalStorage(product) {
      const basketFromLocalStorage = this.getBasketFromLocalStorage();
      if (!basketFromLocalStorage.includes(product.id)) {
        basketFromLocalStorage.push(product.id);

        localStorage.setItem(
          `sale-${this.$store.state.sale.sale.id}`,
          JSON.stringify(basketFromLocalStorage),
        );
      }
    },
    removeProductFromLocalStorage(product) {
      let basketFromLocalStorage = this.getBasketFromLocalStorage();
      if (basketFromLocalStorage.includes(product.id)) {
        basketFromLocalStorage = basketFromLocalStorage.filter(
          (nomenclatureId) => nomenclatureId !== product.id,
        );

        localStorage.setItem(
          `sale-${this.$store.state.sale.sale.id}`,
          JSON.stringify(basketFromLocalStorage),
        );
      }
    },
    getBasketFromLocalStorage() {
      const basketString = localStorage.getItem(
        `sale-${this.$store.state.sale.sale.id}`,
      );
      let basket = [];
      try {
        basket = JSON.parse(basketString) || [];
      } catch (e) {
        console.error(e);
      }

      return basket;
    },
    clearBasketIgnoringLocalStorage() {
      this.basket = [];
    },
  },
};
